<template>
  <div>
    <gc-search-input @updateSearchKeyword="handleFilter" :display-in-browser="displayInBrowser"></gc-search-input>
    <div v-if="memberList && memberList.length > 0">
      <gc-single-selection :member-list="memberList" @updateSelection="handleUpdateSelection"></gc-single-selection>
    </div>
  </div>
</template>

<script>
import EMKT from '../../../constant.js'
import GcSingleSelection from '../../../components/GcSingleSelection.vue'
import GcSearchInput from '../../../components/GcSearchInput.vue'

export default {
  name: 'GcOrderSearchBox',
  components: { GcSingleSelection, GcSearchInput },
  data () {
    return {
      emkt: EMKT,
      keyword: '',
      memberNames: []
    }
  },
  props: {
    memberList: {
      type: Array,
      default: () => []
    },
    displayInBrowser: Boolean
  },
  computed: {
    searchConditionMap () {
      return {
        keyword: this.keyword || '',
        memberNames: this.memberNames || []
      }
    }
  },
  emits: ['updateSearchMap'],
  methods: {
    handleFilter (keyword) {
      this.keyword = keyword
      this.$emit('updateSearchMap', this.searchConditionMap)
    },
    handleUpdateSelection (memberNames) {
      this.memberNames = memberNames
      this.$emit('updateSearchMap', this.searchConditionMap)
    }
  }
}
</script>





// WEBPACK FOOTER //
// GcOrderSearchBox.vue?245881ae